import store from "../redux/store";

export const getCurrentUser = () =>
  JSON.parse(localStorage.getItem("userDetails") || "{}");

export const getAuthToken = () => {
  return localStorage.getItem("token") || "";
};
export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken") || "";
};

export const getToken = () => {
  const token = getAuthToken();
  return token || "";
};

export const handleLogin = (details, response) => {
  localStorage.setItem("token", details?.accessToken);
  localStorage.setItem("userDetails", JSON.stringify(details));
  store.dispatch({
    type: "SESSION:SET_IS_LOGGED_IN",
    payload: {
      value: true,
      userDetails: response,
    },
  });
};
